import { Directive, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { OrderingOption } from 'generated/graphql-types';
import { Observable } from 'rxjs';
import { Register } from 'src/app/common-components/register/models/register';
import { getMailboxPrivileges } from 'src/app/privileges/privileges.selector';
import { MailboxFilterOptions } from './models/mailbox-filter-option';
import { MailboxPrivileges } from './models/mailbox-privileges';
import { MailboxRegisterOptions } from './models/mailbox-register-options';
import { MailboxRegisterListItem } from './models/mailbox-register-results.model';
import { mailboxRegisterAdapterActions, mailboxRegisterInitialFilter } from './state/mailbox-register.actions';
import * as mailboxRegisterReducer from './state/mailbox-register.reducer';

@Directive()
export class MailboxRegister
   extends Register<MailboxRegisterListItem, MailboxRegisterOptions, OrderingOption>
   implements OnInit
{
   columns: string[];

   filters: MailboxFilterOptions[];

   entityName = 'Mailbox';

   mailboxPrivileges$: Observable<MailboxPrivileges>;

   constructor(public store: Store) {
      super(store, mailboxRegisterReducer.selectors, mailboxRegisterAdapterActions);
      this.mailboxPrivileges$ = store.pipe(select(getMailboxPrivileges));
   }

   ngOnInit() {
      this.store.dispatch(mailboxRegisterInitialFilter({ filters: this.filters }));
      this.store.dispatch(this.actions.pageEnter());
   }
}
